import * as types from '../constants/action-types';
import { get } from 'lodash';

const initialState = {
  invoices: { data: [], error: '', isFetching: false, hasFetched: false },
  invoicesByYear: { data: {}, error: '', isFetching: false, hasFetched: false }
};

export default function invoices (state = initialState, action) {
  const { type, data, fetchError } = action;

  switch (type) {
  case types.INVOICES_BY_YEAR_REQUEST: {
    return { ...state,
      invoicesByYear: { isFetching: true }
    }
  }

  case types.INVOICES_BY_YEAR_SUCCESS: {
    return { ...state,
      invoicesByYear: { hasFetched: true, isFetching: false, data }
    }
  }

  case types.INVOICES_BY_YEAR_FAILURE: {
    return { ...state,
      invoicesByYear: { isFetching: false, hasFetched: true, error: fetchError }
    }
  }

  case types.INVOICES_FETCH_REQUEST: {
    return { ...state,
      allInvoices: { isFetching: true }
    }
  }

  case types.INVOICES_FETCH_SUCCESS: {
    return { ...state,
      allInvoices: { hasFetched: true, isFetching: false, data }
    }
  }

  case types.INVOICES_FETCH_FAILURE: {
    return { ...state,
      allInvoices: { hasFetched: true, isFetching: false, error: fetchError }
    }
  }

  case types.INVOICES_YEARS_FETCH_REQUEST: {
    return { ...state,
      invoiceYears: { isFetching: true }
    };
  }

  case types.INVOICES_YEARS_FETCH_SUCCESS: {
    return { ...state,
      invoiceYears: { hasFetched: true, isFetching: false, data }
    };
  }

  case types.INVOICES_YEARS_FETCH_FAILURE: {
    return { ...state,
      invoiceYears: { hasFetched: true, isFetching: false, error: fetchError }
    };
  }

  case types.INVOICE_ENTRIES_FETCH_REQUEST: {
    return { ...state,
      invoiceEntries: { isFetching: true }
    }
  }

  case types.INVOICE_ENTRIES_FETCH_SUCCESS: {
    return { ...state,
      invoiceEntries: { hasFetched: true, isFetching: false, data }
    }
  }

  case types.INVOICE_ENTRIES_FETCH_FAILURE: {
    return { ...state,
      invoiceEntries: { hasFetched: true, isFetching: false, error: fetchError }
    }
  }

  case types.INVOICE_ENTRIES_BY_TYPE_REQUEST: {
    return {...state,
      invoiceEntriesByType: { hasFetched: false, isFetching: true, error: fetchError }
    }
  }

  case types.INVOICE_ENTRIES_BY_TYPE_SUCCESS: {
    const dataObj = {};
    dataObj[get(data, 'entries[0].txn_type')] = data;

    return {...state,
      invoiceEntriesByType: { ...state.invoiceEntriesByType,
        hasFetched: true,
        isFetching: false,
        ...dataObj
      }
    }
  }

  case types.INVOICE_ENTRIES_BY_TYPE_FAILURE: {
    return {...state,
      invoiceEntriesByType: { hasFetched: true, isFetching: false, error: fetchError }
    }
  }

  case types.INVOICE_FETCH_SPACE_RENTALS_REQUEST: {
    return {...state,
      spaceRentals: { hasFetched: false, isFetching: true, error: fetchError }
    }
  }

  case types.INVOICE_FETCH_SPACE_RENTALS_SUCCESS: {
    return {...state,
      spaceRentals: { data: data, hasFetched: true, isFetching: false, error: '' }
    }
  }

  case types.INVOICE_FETCH_SPACE_RENTALS_FAILURE: {
    return {...state,
      spaceRentals: { data: {}, hasFetched: true, isFetching: false, error: fetchError }
    }
  }

  default:
    return state;
  }
}
